import { z } from 'zod';
import { arrayToNonEmptyArray } from './array-to-non-empty-array';
import { RetrievalStatus } from '@prisma/client';

export const retrievalStatusZodEnum = () =>
  z
    .enum(arrayToNonEmptyArray(Object.values(RetrievalStatus)))
    .transform(
      (value) =>
        RetrievalStatus[
          value as keyof typeof RetrievalStatus
        ] as RetrievalStatus,
    );
